<script>
  import { createEventDispatcher } from 'svelte';
  import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Spinner,
  } from 'sveltestrap';

  const dispatch = createEventDispatcher();

  let label = 'Field';
  let field = '';
  let value = '';

  const defaultFormOptions = {
    useDateFilter: false,
  };
  let formOptions = defaultFormOptions;
  let dateFilter = '';

  let open = false;
  let toggle = () => (open = !open);

  export function show(targetField, newLabel, prevValue, options = {}, prevDataExt = {}) {
    label = newLabel || label;
    field = targetField;
    value = prevValue;

    formOptions = { ...defaultFormOptions, ...options };
    dateFilter = prevDataExt.dateFilter || '';

    open = true;
  }

  function submit() {
    const result = {
      field: field,
      value: value,
    };

    if (!!dateFilter) {
      result['extData'] = {
        dateFilter: dateFilter,
      };
    }

    dispatch('filter', result);
    open = false;
  }

  function clearInput() {
    value = '';
  }

</script>

<style>
  .clear-button {
    position: relative;
    float: right;
    margin-top: -2.2rem;
  }
</style>

<Modal isOpen={open} {toggle} style="max-width: 300px;">
  <ModalHeader {toggle}>Column Filter</ModalHeader>
  <ModalBody>
    <div class="row-container">
      <label>Show records where {label} contains:</label>
    </div>
    <div class="row-container">
      <input type="text" class="form-control" bind:value={value} required />
      <button class="btn btn-sm btn-link clear-button" on:click={clearInput}>
        <span class="fa fa-times"></span>
      </button>
    </div>
    {#if formOptions.useDateFilter}
      <div class="row-container" style="padding-top: 0.5rem;">
        <select class="form-control" bind:value={dateFilter}>
          <option value="" selected>---</option>
          <option value="Yesterday">Yesterday</option>
          <option value="Today">Today</option>
          <option value="Tomorrow">Tomorrow</option>
          <option value="Last7Days">Last 7 Days</option>
          <option value="Next7Days">Next 7 Days</option>
          <option value="LastWeek">Last Week</option>
          <option value="ThisWeek">This Week</option>
          <option value="NextWeek">Next Week</option>
          <option value="LastMonth">Last Month</option>
          <option value="ThisMonth">This Month</option>
          <option value="NextMonth">Next Month</option>
          <option value="LastYear">Last Year</option>
          <option value="ThisYear">This Year</option>
          <option value="NextYear">Next Year</option>
        </select>
      </div>
    {/if}
  </ModalBody>
  <ModalFooter>
    <Button color="primary" on:click={submit}>Ok</Button>
    <Button color="secondary" on:click={toggle}>Cancel</Button>
  </ModalFooter>
</Modal>
